// Reglas para ofrecer los modos de práctica al alumno, al inscribir y al
// pedir un cambio de modo.
//
// Cada modo trae desde el backend `aplica_industrial`, `aplica_profesional` y
// `nivel_de_duracion`: una categoría interna que se deduce de sus horas (hasta 200
// horas es nivel 1, hasta 400 nivel 2, hasta 600 nivel 3). No se muestra al
// usuario; solo sirve para estas reglas.

// Ids de api_tipo, los mismos que usa la inscripción.
export const TIPO_INDUSTRIAL = 1;
export const TIPO_PROFESIONAL = 2;

// Id de Ingeniería en Ejecución Informática en api_carrera. Lo usa la
// inscripción, igual que NuevaPractica.vue para decidir el tipo.
export const CARRERA_EJECUCION = 3;

// Nombres exactos con que la solicitud de cambio de modo reconoce la carrera,
// tal como vienen en `carrera` de la práctica.
export const NOMBRE_CARRERA_EJECUCION = "Ingenieria en Ejecucion Informatica";
export const NOMBRE_CARRERA_CIVIL = "Ingeniería Civil Informática";

// Qué reglas de carrera se aplican a la práctica profesional.
export const REGLA_EJECUCION = "ejecucion";
export const REGLA_CIVIL = "civil";

// En Civil Informática los niveles de la industrial y la profesional suman 4:
// una industrial de nivel 1 obliga a una profesional de nivel 3, y una de
// nivel 2 a otra de nivel 2.
const NIVEL_DE_DURACION_TOTAL_CIVIL = 4;

// Ejecución tiene una sola práctica, la profesional, y no admite modos de
// nivel mayor que 2.
const NIVEL_DE_DURACION_MAXIMO_EJECUCION = 2;

// `tipo` puede llegar como número o como texto: NuevaPractica.vue convierte
// todo el formulario a texto al enviarlo, y si el envío falla el alumno sigue
// en la misma pantalla.
export function modoAplicaATipo(modo, tipo) {
    if (Number(tipo) === TIPO_INDUSTRIAL) {
        return modo.aplica_industrial;
    }
    if (Number(tipo) === TIPO_PROFESIONAL) {
        return modo.aplica_profesional;
    }
    return true;
}

// Los modos activos que el alumno puede elegir para una práctica de `tipo`.
// `regla` es REGLA_EJECUCION, REGLA_CIVIL o null; con null la profesional no
// tiene restricciones de carrera. `nivelDeDuracionIndustrial` es el nivel del
// modo de su industrial, si la tiene.
export function modosDisponibles(modos, { tipo, regla, nivelDeDuracionIndustrial }) {
    return modos.filter((modo) => {
        if (!modo.estado || !modoAplicaATipo(modo, tipo)) {
            return false;
        }
        if (Number(tipo) !== TIPO_PROFESIONAL) {
            return true;
        }
        if (regla === REGLA_EJECUCION) {
            return modo.nivel_de_duracion <= NIVEL_DE_DURACION_MAXIMO_EJECUCION;
        }
        if (regla !== REGLA_CIVIL) {
            return true;
        }
        if (nivelDeDuracionIndustrial) {
            return modo.nivel_de_duracion === NIVEL_DE_DURACION_TOTAL_CIVIL - nivelDeDuracionIndustrial;
        }
        // Sin industrial conocida no se puede complementar: se descartan solo
        // los de nivel 1, que nunca completan la profesional de Civil.
        return modo.nivel_de_duracion > 1;
    });
}
